import check from './check'
export default host => ({
  check: check(host),
})